module.exports = __webpack_public_path__ + "static/media/picture39b239b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/galleryUploadIcons/picture.svg
// module id = 1242
// module chunks = 0